/**
 * Use Case: Check if User is Blocked
 *
 * Checks if a user is blocked by current user in encrypted local storage.
 * Matches Flutter implementation: lib/presentation/bottom_sheet/user_actions_bottom_sheet.dart
 */

import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { BlockedUserStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class CheckUserIsBlockedUseCase {
  private storage: SecureStorageWebCrypto;

  constructor() {
    this.storage = SecureStorageWebCrypto.getInstance();
  }

  /**
   * Execute the use case
   * @param userId - The Firebase ID of the user to check
   * @returns boolean - true if user is blocked, false otherwise
   */
  async execute(userId: string): Promise<boolean> {
    const storageKey = SECURE_STORAGE_KEYS.BLOCKED_USERS + userId;
    const blockedUser = await this.storage.getEncrypted<BlockedUserStorage>(storageKey);
    return blockedUser !== null;
  }
}

/**
 * Factory function to create a new CheckUserIsBlockedUseCase instance
 */
export const createCheckUserIsBlockedUseCase = (): CheckUserIsBlockedUseCase => {
  return new CheckUserIsBlockedUseCase();
};
